import React, { Fragment } from 'react';
import Logo from '../Logo.jsx';
import { statusFailed, statusFinal } from '../../util/packageUtils.js';

export default function LogPageSubHeader({ className, status, title }) {
  const isFinished = statusFinal(status);

  return (
    <Fragment>
      <div className={`status-container ${className}`}>
        <strong>Status: </strong>
        <span
          className={
            isFinished
              ? `package-status-${statusFailed(status) ? 'failure' : 'success'}`
              : ''
          }
        >
          {title}
        </span>
      </div>

      {isFinished ? null : (
        <Logo
          caption='Loading...'
          className='packages-loading'
        />
      )}
    </Fragment>
  );
}
